import React from 'react';
import PropTypes from 'prop-types';

export const SendMessageForm = (props) => {

	const { onSubmit } = props;

	return (
		<form className="row padding-bottom" onSubmit={(e) => {
			e.preventDefault();
			if(e.target.message.value === '') return;
			onSubmit(e.target.message.value);
		}}>
			<div className="col-xs-12">
				<ul className="write-message">
					<li className="textarea field-box-nolabel">
						<textarea name="message" id="message" rows="3" style={{ width: '100%' }}></textarea>
					</li>
					<li className="submit">
						<input className="btn btn-primary btn-block" type="submit" value="Send" />
					</li>
				</ul>
			</div>
		</form>
	);
};

SendMessageForm.propTypes = {
	onSubmit: PropTypes.func
}


// WEBPACK FOOTER //
// src/client/components/site/features/networking/pages/elements/SendMessageForm.js